<template>
  <div class="invoice-manage-page">
    <!-- 中间内容 -->
    <div class="invoice-manage-page-content">
      <!-- 面包屑 -->
      <div class="bread">
        <router-link class="bread-item" to="/">上上签</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" :to="'/orders'">订单管理</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" :to="'/invoice-manage'"
          >发票管理</router-link
        >
      </div>

      <!-- tab -->
      <div class="tabs-wrapper">
        <el-tabs v-model="activeTab" type="card" @tab-click="switchTab">
          <el-tab-pane
            :label="item.label"
            :name="item.name"
            v-for="item in orderTabList"
            :key="item.name"
          >
            <!-- 提示 -->
            <div class="invoice-tips">
              <img
                src="../../assets/imgs/invoice-manage/icon-warn.png"
                class="tips-icon"
              />
              <div class="tips-text">
                {{ item.tips }}
              </div>
            </div>
            <div class="invoice-tips" v-if="showFestivalTips">
              <img
                src="../../assets/imgs/invoice-manage/icon-warn.png"
                class="tips-icon"
              />
              <div class="tips-text">亲爱的合作伙伴，我司春节放假时间为：2024年2月6日-2月19日，2024年2月20日恢复正常开票。恭祝各位新春佳节快乐！</div>
            </div>


            <div class="have-data-status" v-show="order.fistLoaded && order.orders.length">
              <!-- 订单列表 -->
              <can-invoicing-orders
                :invoicing-orders="order.orders"
                :selected-orders="order.selectedOrders"
                :check-all-orders="order.checkAllOrders"
                :total-order-price="totalOrderPrice"
                @changeSelectedOrders="onChangeSelectedOrders"
                @changeAllSelect="onChangeAllSelect"
              ></can-invoicing-orders>

              <!-- 开发票表单 -->
              <new-invoice-infos
                v-if="peerInfo.visa_peer_id"
                :pcds="pcds"
                :peer-info="peerInfo"
                :peer-account-info="peerAccountInfo"
                :tax-point="item.name === 'newInvoice' ? 0 : sysConfig.invoice_tax_point"
                :is-histroy="item.name === 'oldInvoice' ? true : false"
                :total-order-price="totalOrderPrice"
                :selected-orders="order.selectedOrders"
                @changeInvoicePercent="onChangeInvoicePercent"
              ></new-invoice-infos>
            </div>

            <!-- 没有订单的时候 -->
            <div class="none-data-status" v-show="order.fistLoaded && order.orders.length === 0">
              <img
                src="../../assets/imgs/invoice-manage/none-order.png"
                class="none-order-img"
              />
              <div class="none-order-text">暂无订单</div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="开票记录" name="historyInvoices">
            <div
              class="have-data-status normal-bottom"
              v-show="invoice.fistLoaded && invoice.totalCount"
            >

              <!-- 历史发票列表 -->
              <history-invoices
                :pcds="pcds"
                :invoices="invoice.invoices"
                @innerUpdatedInvoice="onInnerUpdatedInvoice"
              ></history-invoices>

              <!-- 分页 -->
              <el-pagination
                v-if="invoice.invoices.length"
                class="page-box"
                @current-change="getHistoryInvoicesForPage"
                :current-page="invoice.page"
                :page-size="10"
                layout="prev, pager, next"
                :total="invoice.totalCount"
              >
              </el-pagination>
            </div>

            <!-- 没有数据的时候 -->
            <div
              class="none-data-status"
              v-show="invoice.fistLoaded && invoice.totalCount === 0"
            >
              <img
                src="../../assets/imgs/invoice-manage/none-order.png"
                class="none-order-img"
              />
              <div class="none-order-text">暂无开票历史</div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import canInvoicingOrders from './components/can-invoicing-orders';
import newInvoiceInfos from './components/new-invoice-infos';
import historyInvoices from './components/history-invoices';
import invoiceApi from '../../api/invoice-api';
import utils from '../../libs/utils';
import pcdService from '../../services/pcd-service';
import Http from '../../libs/http';
import User from '../../libs/user';

export default {
  name: 'InvoiceManagePage',
  components: {
    historyInvoices,
    newInvoiceInfos,
    canInvoicingOrders,
  },
  data() {
    return {
      activeTab: '',
      invoiceStatusMap: {
        0: '待支付',
        1: {
          0: '待开具',
          1: '待修改',
          2: '已开票',
        },
        2: '退款成功',
        3: '已取消',
      },
      sysConfig: {}, // 系统配置
      pcds: {}, // 地址数据
      peerInfo: {}, // 同业信息
      peerAccountInfo: {}, // 同业账号信息
      orderTabList: [
        {
          name: 'newInvoice',
          label: '开具发票',
          tips: '只显示2023年4月1日起支付的已完成订单',
        },
        {
          name: 'oldInvoice',
          label: '开具历史发票',
          tips: '只显示2020年至2023年3年31日支付的已完成订单',
        },
      ],
      order: {
        fistLoaded: false,
        loading: false, // 加载可开发票的订单中
        orders: [], // 可开发票的所有订单
        selectedOrders: [], // 已经选中的订单数据
        checkAllOrders: false, // 是否已经选中所有订单
      },
      invoice: {
        fistLoaded: false,
        loading: false, // 记载历史订单众
        invoices: [], // 当前页面的历史发票订单
        totalCount: 0, // 总数量
        page: 1, // 历史发票订单的当前页码
      },
    };
  },
  computed: {
    // 订单价格总计
    totalOrderPrice() {
      let price = 0;
      this.order.selectedOrders.forEach((order) => {
        price += order.invoice_price;
      });
      return price;
    },
    showFestivalTips() {
      const nowDate = new Date().getTime();
      const startDate = new Date('2024-02-05 00:00:00').getTime();
      const endDate = new Date('2024-02-19 23:59:59').getTime();
      if (nowDate > startDate && nowDate < endDate) {
        return true;
      }
      return false;
    },
  },
  created() {
    if (User.isLogin()) {
      this.activeTab = this.$route.query.tab || this.orderTabList[0].name;

      this.getSystemConfig().then(() => {
        this.loadPcdData();
        Promise.all([
          this.getPeerAccountInfo(),
          this.getPeerInfo(),
        ])
          .then(() => {
            this.getInvoicingOrdersForPage();
            this.getHistoryInvoicesForPage();
          });
      });
    } else {
      this.$router.replace({ name: 'index' });
    }
  },
  methods: {

    // 切换tab页面
    switchTab(e) {
      this.$router.replace({
        name: 'invoiceManage',
        query: {
          tab: e.name,
        },
      });
      if (e.name === 'newInvoice' || e.name === 'oldInvoice') {
        // 把订单数据恢复初始值
        this.order = Object.assign({}, this.$options.data().order);
        this.getInvoicingOrdersForPage();
      }

    },

    // 保留两位小数
    toFixed2(price) {
      return (price / 100).toFixed(2);
    },

    // 格式化之后可以直接使用
    formatResultArr(arr) {
      return arr.map(item => ({
        ...item,
        ...{
          submit_date: item.submit_time.substring(0, 16),
          invoice_type_text: item.invoice_type ? '纸质' : '电子',
          header_type_text: item.header_type ? '个人发票' : '企业发票',
          fixed_invoice_price: this.toFixed2(item.invoice_price),
          fixed_cash_fee: this.toFixed2(item.cash_fee),
          status_text: this.getStatusText(item),
        },
      }));
    },

    // 获取状态字符串
    getStatusText(item) {
      if (typeof this.invoiceStatusMap[item.pay_status] === 'string') {
        return this.invoiceStatusMap[item.pay_status];
      }
      return this.invoiceStatusMap[item.pay_status][item.status];
    },

    // 添加是否被选中的属性给到订单
    addIsSelectedAttrToOrder(orders) {
      return orders.map((order) => {
        const tempOrder = { ...order };
        if (typeof tempOrder.is_selected === 'undefined') {
          tempOrder.is_selected = false;
        }
        return tempOrder;
      });
    },

    // 加载当前页面的待开发票的订单列表
    getInvoicingOrdersForPage() {
      if (this.order.loading) return;
      this.order.loading = true;
      return new Promise((resolve, reject) => {
        invoiceApi
          .invoiceOrderBriefQuery({
            is_history: this.activeTab === 'oldInvoice' ? 1 : 0,
          })
          .then((data) => {
            const newOrdersArr = this.addIsSelectedAttrToOrder(data.data);
            this.order.orders = newOrdersArr;
            this.order.loading = false;
            this.order.fistLoaded = true;
            resolve(newOrdersArr);
          })
          .catch((err) => {
            console.log(err);
            utils.msg.error('加载订单列表失败');
            this.order.loading = false;
            this.order.fistLoaded = true;
            reject(err);
          });
      });
    },

    // 加载历史发票记录
    getHistoryInvoicesForPage(page) {
      if (this.invoice.loading) return;
      if (page) this.invoice.page = page;
      this.invoice.loading = true;
      return new Promise((resolve, reject) => {
        invoiceApi
          .invoiceBriefQuery({
            page: this.invoice.page,
          })
          .then((data) => {
            const newInvoiceArr = this.formatResultArr(data.page_data);
            this.invoice.invoices = newInvoiceArr;
            this.invoice.totalCount = data.total_count;
            this.invoice.loading = false;
            this.invoice.fistLoaded = true;
            resolve(newInvoiceArr);
          })
          .catch((err) => {
            console.log(err);
            utils.msg.error('加载历史发票列表失败');
            this.invoice.loading = false;
            this.invoice.fistLoaded = true;
            reject(err);
          });
      });
    },

    // 处理选中了订单的回调
    onChangeSelectedOrders({ checked, order }) {
      const curOrderIndex = _.findIndex(this.order.selectedOrders, innerOrder => innerOrder.id === order.id);

      // 已经在数组中
      if (curOrderIndex > -1) {

        // 移除
        this.order.selectedOrders = this.order.selectedOrders.filter(innerOrder => innerOrder.id !== order.id);

        // 设置选中
        this.setOriginOrderIsSelected(order, checked);
      } else {

        // 不在数组中, 加到后面
        this.order.selectedOrders = [...this.order.selectedOrders, order];

        // 设置选中
        this.setOriginOrderIsSelected(order, checked);
      }
    },

    // 设置原始数组中的选中
    setOriginOrderIsSelected(order, checked) {
      const originIndex = _.findIndex(this.order.orders, innerOrder => innerOrder.id === order.id);

      this.$set(this.order.orders[originIndex], 'is_selected', checked);

      this.order.checkAllOrders = this.order.selectedOrders.length === this.order.orders.length;
    },

    // 切换全选
    onChangeAllSelect({ checked }) {

      // 选中了
      if (checked) {

        // 设置所有原始订单的选中状态
        this.order.orders = this.order.orders.map(order => ({ ...order, is_selected: true }));

        // 将所有原始订单复制到选中到订单
        this.order.selectedOrders = this.order.orders.slice();

        this.order.checkAllOrders = true;
      } else {

        // 取消选中了
        this.order.orders = this.order.orders.map(order => ({ ...order, is_selected: false }));
        this.order.selectedOrders = [];
        this.order.checkAllOrders = false;
      }
    },

    // 加载地址信息
    loadPcdData() {
      pcdService.getPcd().then(pcds => (this.pcds = pcds)).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 获取同业信息
    getPeerInfo() {
      return new Promise((resolve, reject) => {
        Http.post('/visa_peer_query').then((data) => {
          this.peerInfo = data;
          resolve(data);
        }).catch(reject);
      });
    },

    // 获取同业账号信息
    getPeerAccountInfo() {
      return new Promise((resolve, reject) => {
        Http.post('/peer_account_query', {}).then((data) => {
          this.peerAccountInfo = data;
          resolve(data);
        }).catch(reject);
      });
    },

    // 内部更新了发票
    onInnerUpdatedInvoice() {
      this.getHistoryInvoicesForPage();
    },

    // 获取系统配置
    getSystemConfig() {
      return new Promise((resolve, reject) => {
        Http.post('/sys/sys_config_get')
          .then((data) => {
            this.sysConfig = data;
            resolve(data);
          }).catch(() => {
            reject();
          });
      });
    },

    // 开发票的时候检测到费率变更
    onChangeInvoicePercent() {
      this.getSystemConfig();
    },
  },

};
</script>

<style lang="less" scoped>
@import "../../assets/less/variable";
.invoice-manage-page {
  display: flex;
  flex-direction: column;
  .invoice-manage-page-content {
    width: 1120px;
    margin: 0 auto 40px auto;
    .tabs-wrapper {
      background: #ffffff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
      /deep/ .el-tabs__header {
        background-color: #f3f6f9;
        border-bottom: 0;
        margin-bottom: 0;
        .el-tabs__item {
          background-color: #f3f6f9;
          width: 140px;
          color: #5f666e;
          text-align: center;
          font-size: 16px;
          border: 0;
          &.is-active {
            background-color: white;
            color: #2f333d;
          }
        }
      }
      /deep/ .el-tabs__content {
        .el-tab-pane {
          padding-top: 24px;
        }
      }

      .invoice-tips {
        align-self: flex-start;
        height: 32px;
        background: #fff6dd;
        border-radius: 2px;
        display: inline-flex;
        align-items: center;
        padding: 0 12px;
        margin-left: 24px;
        & + .invoice-tips{
          margin-top: 12px;
        }
        .tips-icon {
          width: 16px;
          height: 16px;
        }
        .tips-text {
          margin-left: 6px;
          font-size: 14px;
          font-weight: 400;
          color: #ff8033;
        }
      }

      .have-data-status {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 24px 82px 24px;
        &.normal-bottom {
          padding: 0 24px 24px 24px;
        }

        .page-box {
          margin-top: 40px;
        }
      }
      .none-data-status {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 173px;
        .none-order-img {
          margin-top: 60px;
          width: 280px;
          height: 180px;
        }
        .none-order-text {
          margin-top: 10px;
          font-size: 16px;
          color: #c9cdd1;
          line-height: 22px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice-manage/InvoiceManage.vue